import { Modal } from "antd";
import { TableComposicaoContaData } from "core/features/conta/typings";
import FooterModal from "ui/components/Button/FooterModal";
import TableComposicaoConta from "components/ContentDetalheConta/components/TableComposicaoConta";

interface ModalComposicaoContaProps {
  isOpen: boolean;
  onClose: () => any;
  data: TableComposicaoContaData;
  title?: string;
  tableTitle?: string;
}

function ModalComposicaoConta({
  isOpen,
  onClose,
  data,
  title,
  tableTitle,
}: ModalComposicaoContaProps) {
  return (
    <Modal
      centered
      visible={isOpen}
      footer={
        <FooterModal
          showRegisterAnother={false}
          onClose={onClose}
          buttonCancelarText="Fechar"
        />
      }
      title={title || `Composição da conta`}
      destroyOnClose
      onCancel={onClose}
      closable={true}
      width="900px"
      keyboard={false}
    >
      <TableComposicaoConta data={data} title={tableTitle} />
    </Modal>
  );
}

export default ModalComposicaoConta;
